import React from "react";
import { Button } from "@chakra-ui/react";

const GradiantBtn = ({
  title,
  onClick,
  isDisabled,
  isLoading,
  loadingText,
}) => {
  return (
    <Button
      w={"full"}
      fontSize={14}
      fontWeight={"medium"}
      color={"#fff"}
      bgGradient={"linear(to-l, #34aadc, #1cae81)"}
      onClick={onClick}
      isDisabled={isDisabled}
      isLoading={isLoading}
      loadingText={loadingText}
      _focusVisible={{
        outline: "none",
      }}
      _hover={{
        bgGradient: "linear(to-l, #46b5e4, #29c192)",
      }}
    >
      {title}
    </Button>
  );
};

export default GradiantBtn;
